import { render, staticRenderFns } from "./MyAddresss.vue?vue&type=template&id=31b1a1e7&scoped=true&"
import script from "./MyAddresss.vue?vue&type=script&lang=js&"
export * from "./MyAddresss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b1a1e7",
  null
  
)

export default component.exports